import { useState } from 'react';

import { TUseSearchableSelectParams } from '@/shared/components/ui/form/components/searchable-select/hooks/use-searchable-select/use-searchable-select.types';

export const useSearchableSelect = <TOptionShape>({
  onSelectChange,
  multiple,
}: TUseSearchableSelectParams<TOptionShape> = {}) => {
  const [inputValue, setInputValue] = useState<string>('');
  const [shouldSearch, setShouldSearch] = useState(true);

  const handleInputChange = (
    _: unknown,
    newInputValue: string,
    reason: string,
  ) => {
    // In multiple mode MUI only ever writes '' back, so typing is the only
    // reason worth honouring — the rest drop the prefix still being matched.
    if (multiple && reason !== 'input') {
      return;
    }
    // `inputValue` controls MUI's input, so it must track every reason or the
    // field freezes; only typing searches — text MUI writes back is no search term.
    setInputValue(newInputValue);
    setShouldSearch(reason === 'input');
  };

  const handleSelectChange = (
    selectedOptions: TOptionShape[],
    value: TOptionShape | TOptionShape[],
    setValue: (value: TOptionShape | TOptionShape[]) => void,
  ) => {
    // Multi keeps searching the retained prefix; single collapses to the label.
    if (!multiple) {
      setShouldSearch(false);
    }
    if (onSelectChange) {
      onSelectChange(selectedOptions, value, setValue);
    }
  };

  return {
    inputValue,
    shouldSearch,
    handleSelectChange,
    handleInputChange,
  };
};
